import { render, staticRenderFns } from "./Online.vue?vue&type=template&id=15b5025e&scoped=true&"
import script from "./Online.vue?vue&type=script&lang=js&"
export * from "./Online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5025e",
  null
  
)

export default component.exports